/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2020, 2021
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import _ from 'lodash';

/*
 * Utility module to manage the CMaaS functions
 */

const ROUTE_PATH = 'digitalData.page.pageInfo.ibm.messaging.routing';
const CONSULTATION = 'Book a consultation';

export const hasContactModule = () => {
  return !!_.get(window, ROUTE_PATH + '.focusArea');
};

export const hasScheduler = () => {
  const check = document.getElementById('scheduler-check');
  return hasContactModule() && check?.textContent === CONSULTATION;
};

export const setFocusArea = focusArea => {
  _.set(window, ROUTE_PATH, {
    focusArea,
    country: 'US',
    language: 'en'
  });
};

export const schedulerProp = { 'data-ibm-contact': 'scheduler-link' };
